<template>
  <v-dialog v-model="dialog" persistent max-width="720px">
    <v-card class="rounded-lg elevation-3 overflow-hidden">
      <!-- Toolbar Header Principal -->
      <v-toolbar
        color="secondary"
        dark
        flat
        class="table-header-toolbar px-2 px-sm-4"
      >
        <div class="d-flex align-center header-main-info flex-grow-1 min-width-0">
          <div class="header-icon-box mr-2 mr-sm-3 flex-shrink-0">
            <v-icon color="white">{{
              Item.id == 0 ? "mdi-domain-plus" : "mdi-domain-edit"
            }}</v-icon>
          </div>
          <div class="header-text-block min-width-0 mr-2 mr-sm-3">
            <div class="header-company-title font-weight-bold text-truncate">
              {{ Item.id == 0 ? "Registro de Cliente" : "Editar Cliente" }}
            </div>
          </div>
          <v-chip
            v-if="Item.id > 0"
            small
            color="white"
            text-color="secondary"
            class="header-count-chip font-weight-bold elevation-1 flex-shrink-0"
          >
            <v-icon left size="15" color="secondary">mdi-pound</v-icon>
            ID: {{ Item.id }}
          </v-chip>
        </div>

        <div class="header-help-btn ml-1 ml-sm-2 flex-shrink-0">
          <v-btn icon dark @click="cerrarDialogo()" class="btn-circle-tooltip">
            <v-icon size="20">mdi-close</v-icon>
          </v-btn>
        </div>
      </v-toolbar>

      <v-card-text class="pa-3 pa-sm-4 pa-md-5">
        <v-form enctype="multipart/form-data" ref="form" lazy-validation>
          <!-- SECCIÓN 1: DATOS PRINCIPALES DE LA EMPRESA -->
          <div class="section-title d-flex align-center mb-3">
            <v-icon color="secondary" small class="mr-2">mdi-domain</v-icon>
            <span class="text-subtitle-2 font-weight-bold text--primary">
              Datos Principales de la Empresa
            </span>
          </div>

          <v-row dense class="mb-2">
            <v-col cols="12" sm="6" class="pa-2">
              <v-text-field
                label="Razón Social *"
                placeholder="Ej. Transportes El Sol S.A.C."
                hide-details="auto"
                v-model="Item.razon_social"
                outlined
                dense
                prepend-inner-icon="mdi-domain"
                class="rounded-lg"
                :rules="requeridos"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" class="pa-2">
              <v-text-field
                label="Apodo / Slug *"
                placeholder="Ej. ElSol (sin espacios ni caracteres)"
                hide-details="auto"
                v-model="Item.slug"
                outlined
                dense
                prepend-inner-icon="mdi-tag-outline"
                class="rounded-lg"
                :rules="requeridosslug"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" class="pa-2">
              <v-text-field
                label="RUC *"
                placeholder="11 dígitos"
                hide-details="auto"
                v-model="Item.ruc"
                type="number"
                outlined
                dense
                prepend-inner-icon="mdi-card-account-details-outline"
                class="rounded-lg"
                :rules="[
                  ...requeridos,
                  (val) =>
                    (val && val.toString().length <= 11) ||
                    'Máximo 11 caracteres',
                ]"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" class="pa-2">
              <v-autocomplete
                v-model="Item.id_sectors"
                :items="Sectores"
                dense
                outlined
                hide-details="auto"
                prepend-inner-icon="mdi-shape-outline"
                label="Seleccionar Sector *"
                :rules="requeridos"
                class="rounded-lg"
              >
                <template v-slot:append-outer>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="success"
                        fab
                        x-small
                        dark
                        class="elevation-1 action-btn"
                        @click="openModalSectores()"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon x-small>mdi-plus</v-icon>
                      </v-btn>
                    </template>
                    <span>Nuevo Sector</span>
                  </v-tooltip>
                </template>
              </v-autocomplete>
            </v-col>

            <v-col cols="12" class="pa-2">
              <v-text-field
                label="Dirección Fiscal *"
                placeholder="Av. Principal 123..."
                hide-details="auto"
                v-model="Item.direccion"
                outlined
                dense
                prepend-inner-icon="mdi-map-marker-outline"
                class="rounded-lg"
                :rules="requeridos"
              ></v-text-field>
            </v-col>
          </v-row>

          <!-- SECCIÓN 2: CONFIGURACIÓN (Solo en edición) -->
          <div
            class="section-title d-flex align-center mb-3 mt-3"
            v-if="Item.id > 0"
          >
            <v-icon color="secondary" small class="mr-2">mdi-tune</v-icon>
            <span class="text-subtitle-2 font-weight-bold text--primary">
              Configuración y Preferencias
            </span>
          </div>

          <v-row dense class="mb-2" v-if="Item.id > 0">
            <v-col cols="12" sm="6" class="pa-2">
              <v-autocomplete
                v-model="Item.estado"
                :items="['Activo', 'Inactivo']"
                dense
                outlined
                hide-details="auto"
                prepend-inner-icon="mdi-check-circle-outline"
                label="Estado *"
                :rules="requeridos"
                class="rounded-lg"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="6" class="pa-2">
              <v-autocomplete
                v-model="Item.costo"
                :items="['Costo por Kilometro', 'Costo por hora']"
                dense
                outlined
                hide-details="auto"
                prepend-inner-icon="mdi-speedometer"
                label="Indicador por Defecto *"
                :rules="requeridos"
                class="rounded-lg"
              ></v-autocomplete>
            </v-col>
          </v-row>

          <!-- SECCIÓN 3: LOGOTIPO DEL CLIENTE -->
          <div class="section-title d-flex align-center mb-3 mt-3">
            <v-icon color="secondary" small class="mr-2">mdi-image-outline</v-icon>
            <span class="text-subtitle-2 font-weight-bold text--primary">
              Logotipo del Cliente (.PNG, .JPG)
            </span>
          </div>

          <v-row dense class="align-center mb-1">
            <v-col cols="12" sm="7" class="pa-2">
              <v-file-input
                id="img_firma"
                label="Seleccionar Logotipo"
                outlined
                dense
                prepend-icon=""
                prepend-inner-icon="mdi-camera"
                accept="image/png, .jpeg, .jpg"
                @change="ObtenerImagen"
                :rules="Item.id > 0 ? [] : requeridos"
                class="rounded-lg"
                show-size
                truncate-length="25"
                hide-details="auto"
              ></v-file-input>
              <span class="caption text--secondary mt-2 d-block">
                <v-icon x-small color="grey">mdi-information-outline</v-icon>
                Se recomienda formato PNG transparente para un acabado profesional.
              </span>
            </v-col>

            <v-col cols="12" sm="5" class="pa-2">
              <div class="logo-preview-box elevation-1 rounded-lg">
                <img
                  id="imagenFirmaPrevio"
                  :src="Item.imagen ? Item.imagen : imagen"
                  alt="logo_cliente"
                  class="logo-preview-img"
                />
                <span class="caption text--secondary mt-1 font-weight-medium">
                  Vista Previa
                </span>
              </div>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <!-- Botones de Acción / Footer -->
      <v-card-actions class="form-card-actions pa-3 pa-sm-4 bg-light border-top d-flex justify-end align-center">
        <v-btn
          outlined
          color="grey darken-1"
          class="btn-form-action text-capitalize px-4 rounded-lg mr-sm-2 font-weight-medium"
          @click="cerrarDialogo()"
        >
          <v-icon left small>mdi-close</v-icon>
          Cancelar
        </v-btn>
        <v-btn
          v-if="Item.id == 0"
          color="primary"
          elevation="1"
          class="btn-form-action text-capitalize px-5 rounded-lg font-weight-bold"
          @click="agregar()"
          :loading="loader"
          :disabled="loader"
        >
          <v-icon left small>mdi-content-save</v-icon>
          Guardar Cliente
        </v-btn>
        <v-btn
          v-else
          color="primary"
          elevation="1"
          class="btn-form-action text-capitalize px-5 rounded-lg font-weight-bold"
          @click="agregar()"
          :loading="loader"
          :disabled="loader"
        >
          <v-icon left small>mdi-pencil</v-icon>
          Actualizar Cliente
        </v-btn>
      </v-card-actions>
    </v-card>

    <!-- MODAL AGREGAR SECTOR MEJORADO -->
    <v-dialog
      v-model="dialogSector"
      max-width="420px"
      v-if="dialogSector == true"
    >
      <v-card class="rounded-lg elevation-3 overflow-hidden">
        <v-toolbar height="50" color="secondary" dark flat class="px-3">
          <v-icon left small>mdi-shape-plus</v-icon>
          <span class="text-subtitle-1 font-weight-bold">
            Agregar Nuevo Sector
          </span>
          <v-spacer></v-spacer>
          <v-btn icon dark small @click="closeModalSectores()">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="pa-4">
          <v-form ref="form_sector" v-model="valid">
            <v-text-field
              label="Nombre del Sector *"
              placeholder="Ej. Minería, Transporte..."
              v-model="sector"
              outlined
              dense
              prepend-inner-icon="mdi-tag-plus"
              class="rounded-lg mt-2"
              hide-details="auto"
              :rules="[(v) => !!v || 'Sector es requerido']"
            ></v-text-field>
            <div
              v-if="mostrarLabelDuplicado"
              class="red--text caption mt-2 d-flex align-center"
            >
              <v-icon color="error" x-small class="mr-1">mdi-alert-circle</v-icon>
              El sector ya se encuentra registrado.
            </div>
          </v-form>
        </v-card-text>

        <v-card-actions class="form-card-actions pa-3 bg-light border-top d-flex justify-end">
          <v-btn
            outlined
            color="grey darken-1"
            small
            class="btn-form-action text-capitalize px-3 rounded-lg mr-sm-2"
            @click="closeModalSectores()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            elevation="1"
            small
            class="btn-form-action text-capitalize px-4 rounded-lg font-weight-bold"
            :disabled="!valid"
            @click="addSector(sector)"
          >
            <v-icon left small>mdi-plus</v-icon>
            Agregar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay v-if="loader" :model-value="loader" class="align-center justify-center">
      <div class="text-center white--text">
        <p class="font-weight-bold text-subtitle-1 mb-2">
          {{ Item.id == 0 ? 'Creando cliente...' : 'Actualizando cliente...' }}
        </p>
        <v-progress-circular
          color="white"
          size="56"
          width="5"
          indeterminate
        ></v-progress-circular>
      </div>
    </v-overlay>

    <MensajeTransicion
      color="#FA694A"
      :text="mensaje"
      v-if="verAlerta"
      :top="true"
      :bottom="false"
    />
  </v-dialog>
</template>

<script>
import {
    mapState,
    mapActions
} from 'vuex';
import MensajeTransicion from "../Alerta.vue"
export default {
    props: ['dialog', 'Item', 'Titulo'],
    components: {
        MensajeTransicion
    },
    data() {
        return {
            imagenminiatura: '/images/reporte/imagen_no_disponible.jpg',
            emailRules: [
                v => !!v || 'E-mail es requerido',
                v => /.+@.+\..+/.test(v) || 'E-mail no es valido',
            ],
            show1: false,
            rules: {
                required: v => !!v || 'Requerido.',
                min: v => v.length >= 6 || 'Min 6 characters'
            },
            requeridos: [
                v => !!v || 'Este Campo es Requerido.'
            ],
            requeridosslug:[
                v => !!v || 'Este Campo es requerido',
                v => /^[a-zA-Z0-9]+$/.test(v) || 'No se permiten caracteres especiales',
                v => v.length>=6 || 'Min 6 caracteres',
                v => v.length<=15 || 'Max 15 caracteres',
            ],
            mensaje: "",
            verAlerta: false,
            valid: true,
            sector: null,
            dialogSector: false,
            mostrarLabelDuplicado: false,
            loader:false,
        };
    },
    computed: {
        ...mapState("navigation", ["Permisos"]),
        ...mapState("sector", ["Sectores"]),
        ...mapState('cliente',['validacionapodo']),
        imagen() {
            return this.imagenminiatura;
        }
    },
    methods: {
        ...mapActions('cliente', ['agregarCliente', 'cargarCliente']),
        ...mapActions('sector', ['crearSector']),

        async agregar() {
            if (this.$refs.form.validate()) {
                this.$alertify.confirm(
                    this.Item.id == 0 ? "Realmente desea registra el cliente!" : "Realmente desea editar el cliente!",
                    () => {
                        if (this.Item.id == 0) {
                            this.loader=true;
                            this.agregarCliente(this.Item)
                                .then(r => { 
                                    if (this.validacionapodo!='error') {   
                                        this.LimpiarCampos();
                                        this.cerrarDialogo();   
                                    }
                                    this.loader=false;
                                });
                        } else {
                                this.agregarCliente(this.Item)
                                    .then(r => {
                                        if (this.validacionapodo!='error') {   
                                            this.LimpiarCampos();
                                            this.cerrarDialogo();   
                                        }
                                        this.loader=false;
                                    });
                        }
                    },
                    () => {
                        this.cargarCliente()
                        this.$alertify.error("Se cancelo la acción")
                    }
                ).setHeader('<h3> Aviso </h3>').set('labels', { ok: 'Aceptar', cancel: 'Cancelar' });
            }
        },
        LimpiarCampos() {
            this.Item.id = 0,
                this.Item.razon_social = '',
                this.Item.ruc = '',
                this.Item.estado = '',
                this.Item.ruta_logo = '',
                this.Item.costo = '',
                this.Item.imagen = '',
                this.Item.slug = '',
                this.Item.direccion = ''
        },
        cerrarDialogo() {
            this.$emit('closeDialog');
        },
        ObtenerImagen() {
            let file = document.getElementById('img_firma').files[0];
            this.Item.ruta_logo = file;
            this.CargarImagen(file)
        },
        CargarImagen(file) {
            let reader = new FileReader();
            reader.onload = (e) => {
                this.imagenminiatura = e.target.result;
            }
            reader.readAsDataURL(file)
        },

        openModalSectores() {
            this.dialogSector = true;
        },

        closeModalSectores() {
            this.sector = null;
            this.dialogSector = false;
        },

        async addSector(sector) {
            let exists = this.Sectores.some(element => element.text == sector);
            if (exists) {
                this.mostrarLabelDuplicado = true;
            } else {
                this.mostrarLabelDuplicado = false;
                let rpta = await this.crearSector({sector: this.sector});
                console.log(rpta);
                this.Sectores.push({value: rpta.id, text: rpta.name});
                this.closeModalSectores();
            }
        }
    },
}
</script>

<style scoped>
.min-width-0 {
  min-width: 0;
}

.table-header-toolbar {
  min-height: 58px;
}

.header-main-info {
  overflow: hidden;
}

.header-icon-box {
  background: rgba(255, 255, 255, 0.18);
  border-radius: 8px;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.header-company-title {
  font-size: 1.08rem;
  letter-spacing: -0.2px;
}

.header-count-chip {
  font-size: 0.85rem;
  height: 28px;
}

.section-title {
  border-left: 3px solid var(--v-secondary-base, #424242);
  padding-left: 8px;
}

.bg-light {
  background-color: #f8fafc !important;
}

.border-top {
  border-top: 1px solid #e2e8f0 !important;
}

.logo-preview-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #f8fafc;
  border: 1px dashed #cbd5e1;
  padding: 12px;
  min-height: 110px;
}

.logo-preview-img {
  max-width: 130px;
  max-height: 70px;
  object-fit: contain;
  background: #ffffff;
  padding: 4px;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
}

.action-btn {
  transition: transform 0.18s ease-in-out, box-shadow 0.18s ease-in-out !important;
}

.action-btn:hover {
  transform: scale(1.1) !important;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2) !important;
}

.btn-circle-tooltip {
  background: rgba(255, 255, 255, 0.16) !important;
  border: 1px solid rgba(255, 255, 255, 0.25) !important;
  border-radius: 50% !important;
  width: 36px !important;
  height: 36px !important;
  min-width: 36px !important;
  max-width: 36px !important;
  padding: 0 !important;
  margin: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  text-decoration: none !important;
  transition: all 0.2s ease-in-out !important;
}

.btn-circle-tooltip:hover {
  background: rgba(255, 255, 255, 0.28) !important;
  border-color: rgba(255, 255, 255, 0.45) !important;
}

/* ============================================================
   RESPONSIVE: Mobile (max 600px)
   ============================================================ */
@media (max-width: 600px) {
  .table-header-toolbar {
    min-height: 48px;
  }

  .table-header-toolbar ::v-deep .v-toolbar__content {
    padding: 6px 10px !important;
  }

  .header-icon-box {
    width: 30px;
    height: 30px;
    min-width: 30px;
    border-radius: 6px;
  }

  .header-icon-box .v-icon {
    font-size: 18px !important;
  }

  .header-company-title {
    font-size: 0.85rem !important;
    line-height: 1.2;
  }

  .header-count-chip {
    font-size: 0.7rem !important;
    height: 22px !important;
    padding: 0 5px !important;
  }

  .header-count-chip .v-icon {
    font-size: 12px !important;
    margin-right: 2px !important;
  }

  .form-card-actions {
    flex-direction: column-reverse !important;
    align-items: stretch !important;
    gap: 8px !important;
    padding: 12px 14px !important;
  }

  .form-card-actions ::v-deep .v-btn,
  .form-card-actions .btn-form-action {
    width: 100% !important;
    max-width: 100% !important;
    display: flex !important;
    justify-content: center !important;
    margin: 0 !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  .form-card-actions ::v-deep .v-btn + .v-btn {
    margin-left: 0 !important;
  }
}
</style>

